module.exports = __webpack_public_path__ + "img/add-image10.f7dfe3a0.png";